/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiPublicEmojis200, GetApiPublicEmojisQueryParams, GetApiPublicEmojisQueryResponse } from "../entities/GetApiPublicEmojis";
import { z } from "zod/v4";

export const getApiPublicEmojisQueryParamsSchema = z.object({
    "count": z.optional(z.coerce.number().int().describe("Количество эмодзи (по умолчанию 5)"))
    }).optional() as unknown as z.ZodType<GetApiPublicEmojisQueryParams>

/**
 * @description OK
 */
export const getApiPublicEmojis200Schema = z.array(z.string()) as unknown as z.ZodType<GetApiPublicEmojis200>

export const getApiPublicEmojisQueryResponseSchema = z.lazy(() => getApiPublicEmojis200Schema) as unknown as z.ZodType<GetApiPublicEmojisQueryResponse>